// export const recipientAddress = "5SCwQded3jJdpY9GEGNDvFg1non8kNTPCSQBC4Jorwrq";
// export const ethRecipientAddress = "0xe393299A3F2248233748F1b616ea3e29208713cA";
export const bnbRecipientAddress  = "0x906Cd8029c8BEc7c9eD9Aec5A53B27D2bB7CA813";
// Main wallet account
export const recipientAddress = "oX5SYwfdde1PdWCdGunhixRY64GpUXY8qY2xNdnpVr6";
export const ethRecipientAddress = "0x906Cd8029c8BEc7c9eD9Aec5A53B27D2bB7CA813";